import { IChecklistTemplate } from 'features/inventory/checklist/types';
import { BaseService } from 'shared/services/BaseService';

class EquipmentCheckListTemplateService extends BaseService<IChecklistTemplate> {
  constructor() {
    super('checklist-templates');
    this.canDelete = true;
  }
}

export const equipmentCheckListTemplateService = new EquipmentCheckListTemplateService();
